import React from 'react'

const Fees = ({ color, size }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={`size-${size || 6}`} viewBox="0 0 24 24" fill="none" stroke={color || "currentColor"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/>
        <path d="m15 9-6 6"/>
        <path d="M9 9h.01"/>
        <path d="M15 15h.01"/>
    </svg>
  )
}

export default Fees